<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<h1 class="h1"><span aria-label="v" epub:type="pagebreak" id="page_v" role="doc-pagebreak"><span class="gray">CONTENTS</span></span></h1>
<p class="tocfm"><a href="#/xhtml/foreword#foreword">Foreword</a></p>
<p class="tocfm"><a href="#/xhtml/preface#preface">Preface</a></p>
<p class="tocfm"><a href="#/xhtml/intro#intro">Introduction: Defining the Inclusive Leader</a></p>
<p class="tocfm"><a href="#/xhtml/core#core">The Core of Inclusive Leadership: The Enabling Traits</a></p>
<p class="tocpart"><a href="#/xhtml/part1#part1">PART 1. THE FIVE DISCIPLINES</a></p>
<p class="tocchap"><span href="#/xhtml/ch01#ch1" title="Link target outside of Sample">1. Discipline 1: Builds Interpersonal Trust</span></p>
<p class="tocchap"><span href="#/xhtml/ch02#ch2" title="Link target outside of Sample">2. Discipline 2: Integrates Diverse Perspectives</span></p>
<p class="tocchap"><span href="#/xhtml/ch03#ch3" title="Link target outside of Sample">3. Discipline 3: Optimizes Talent</span></p>
<p class="tocchap"><span href="#/xhtml/ch04#ch4" title="Link target outside of Sample">4. Discipline 4: Applies an Adaptive Mindset</span></p>
<p class="tocchap"><span href="#/xhtml/ch05#ch5" title="Link target outside of Sample">5. Discipline 5: Achieves Transformation</span></p>
<p class="tocpart"><span href="#/xhtml/part2#part2" title="Link target outside of Sample">PART 2. THE EXEMPLARS</span></p>
<p class="tocchap"><span href="#/xhtml/ch06#ch6" title="Link target outside of Sample">6. Barilla: Preserving Tradition While Changing It</span></p>
<p class="tocchap"><span href="#/xhtml/ch07#ch7" title="Link target outside of Sample">7. John Deere: Inclusive Leadership Feeds the World</span></p>
<p class="tocchap"><span href="#/xhtml/ch08#ch8" title="Link target outside of Sample">8. Marriott: Where Everyone Belongs</span></p>
<p class="tocchap"><span href="#/xhtml/ch09#ch9" title="Link target outside of Sample">9. Ravinia Festival: Setting the Stage from the Stage</span></p>
<p class="tocpart"><span href="#/xhtml/part3#part3" title="Link target outside of Sample">PART 3. TACKLING THE MEGA DIVERSITY AND INCLUSION CHALLENGES</span></p>
<p class="tocchap1"><span href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10. Structural Inclusion: Confronting the Reference Man Norms That Leave Most of Us Out</span></p>
<p class="tocchap1"><span href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11. Identity Inclusion: The Perennial Unfinished Business of Race and Gender</span></p>
<p class="tocchap1"><span href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12. Sociopolitical Inclusion: When the Outside Comes Inside</span></p>
<p class="tocbm"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">Conclusion. Creating Inclusive Organizations—Who Has the Last Word?</span></p>
<p class="tocbma"><span aria-label="vi" epub:type="pagebreak" id="page_vi" role="doc-pagebreak"><span href="#/xhtml/appa#appa" title="Link target outside of Sample">Appendix A. Bonus Tracks: Spotlight on the Enabling Traits and Structural Inclusion</span></span></p>
<p class="tocbma"><span href="#/xhtml/appb#appb" title="Link target outside of Sample">Appendix B. Research Methods behind Korn Ferry’s Inclusive Leader Model</span></p>
<p class="tocbma"><span href="#/xhtml/appc#appc" title="Link target outside of Sample">Appendix C. Resources</span></p>
<p class="tocfm"><span href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocfm"><span href="#/xhtml/gloss#gloss" title="Link target outside of Sample">Glossary</span></p>
<p class="tocfm"><span href="#/xhtml/bib#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="tocfm"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="tocfm"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="tocfm"><span href="#/xhtml/about#about" title="Link target outside of Sample">About the Authors</span></p>
<p class="tocfm"><span href="#/xhtml/about1#about1" title="Link target outside of Sample">About Korn Ferry</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?68697aa0